import { getters } from './getters';
import * as actions from './actions';
import { state } from './models';
import { mutations } from './mutations';

export const menuManagerModule = {
  state,
  getters,
  actions,
  mutations,
};
